module.exports = __webpack_public_path__ + "static/img/bg-tit1.abe26a8c.png";